class Comparitor {
  constructor(element, selected, featuredImageUrl, productTitle) {
    this.element = element;
    this.selected = selected;
    this.featuredImageUrl = featuredImageUrl;
    this.productTitle = productTitle
  }


  handleClick(order) {
    var className = "selected_" + order;
    var eventName = "comparitor-toggled";
    this.element.classList.toggle(className);
    if (this.element.classList.contains(className)) {
      document.dispatchEvent(new CustomEvent(eventName, { detail: { toggle: "selected", order: order, sender: this.element, featuredImageUrl: this.featuredImageUrl, productTitle: this.productTitle } }));
    }
    else {
      document.dispatchEvent(new CustomEvent(eventName, { detail: { toggle: "removed", order: order, sender: this.element, featuredImageUrl: this.featuredImageUrl, productTitle: this.productTitle } }));
    }
  }
}

class CardInformationButtons extends HTMLElement {
  constructor() {
    super();
    // alert("card information buttons created");
    this.productUrl = this.getAttribute("product-url");
    this.featuredImageUrl = this.getAttribute("image-url");
    this.productTitle = this.getAttribute("product-title");
    // this.initQuickView();
  }

  connectedCallback () {
    this.getButtons();

    // quick view button handling 
    this.quickViewButton.addEventListener("click", () => this.handleQuickView());

    // comparitor handling 
    this.firstComparitor = this.resetComparitor();
    this.secondComparitor = this.resetComparitor();
    this.compareButton.addEventListener("click", () => this.comparitorSender());
    document.addEventListener("comparitor-toggled", (e) => this.comparitorReceiver(e),);
  }

  //get card buttons
  getButtons (){
    this.quickViewButton = this.querySelector("button[class*='quick-view-button']");
    this.magnifyButton = this.querySelector("button[class*='magnify-button']");
    // this.addToCartButton = this.querySelector("button[class*='add-to-cart-button']");
    this.compareButton = this.querySelector("button[class*='compare-button']");
    // console.log("found: " + this.quickViewButton.id + " " + this.magnifyButton.id + " " + this.compareButton.id);
    
    this.dispatchEvent(new CustomEvent("buttons-ready"));
  }

  resetComparitor(element = this.compareButton, selected = false, featuredImageUrl = this.featuredImageUrl, productTitle = this.productTitle) {
    return new Comparitor(element, selected, featuredImageUrl, productTitle);
  }

  // set up comparitor button click listener 
  comparitorSender() {
      if(!this.firstComparitor.selected || this.firstComparitor.element === this.compareButton) {
        this.firstComparitor.handleClick("first");
        if(this.secondComparitor.selected) {
          this.secondComparitor.handleClick("first");
          this.secondComparitor.handleClick("second");
        }
      }
      else if (!this.secondComparitor.selected || this.secondComparitor.element == this.compareButton) {
        this.secondComparitor.handleClick("second");
      }
      else {
        this.toggleBothComparitors();
        this.comparitorSender();
      }
  }

  toggleBothComparitors() {
    this.firstComparitor.handleClick("first");
    this.secondComparitor.handleClick("second");
  }

  // set up comparitor custom event listener 
  comparitorReceiver(e) {
      switch (e.detail.order + " comparitor " + e.detail.toggle) {
        case "first comparitor selected":
          this.firstComparitor = this.resetComparitor(e.detail.sender, true, e.detail.featuredImageUrl, e.detail.productTitle);
          // console.log("first comparitor selected " + this.firstComparitor.element.className + " url: " + this.firstComparitor.featuredImageUrl + " title: " + e.detail.productTitle);
          console.log(`%c[MassTech / Card Information Buttons / Compare] first comparitor selected ${e.detail.productTitle}`, "color: DarkOrchid");
          if(this.compareButton != e.detail.sender) {this.compareButton.classList.add("first_selected");}
          break;
        case "first comparitor removed": 
          // console.log("first comparitor removed " + e.detail.sender.className + " url: " + e.detail.featuredImageUrl + " title: " + e.detail.productTitle);
          console.log(`%c[MassTech / Card Information Buttons / Compare] first comparitor removed ${e.detail.productTitle}`, "color: Sienna");
          this.firstComparitor = this.resetComparitor();
          this.compareButton.classList.remove("first_selected");
          break;
        case "second comparitor selected":
          this.secondComparitor = this.resetComparitor(e.detail.sender, true, e.detail.featuredImageUrl, e.detail.productTitle);
          this.compareButton.classList.remove("first_selected");
          // console.log("second comparitor selected " + this.firstComparitor.element.className + " url: " + this.firstComparitor.featuredImageUrl + " title: " + e.detail.productTitle);
          console.log(`%c[MassTech / Card Information Buttons / Compare] second comparitor selected ${e.detail.productTitle}`, "color: DarkOrchid");
          var inlineString = `<div id="image-compare">
              <img src="${this.firstComparitor.featuredImageUrl}">
              <img src="${this.secondComparitor.featuredImageUrl}">
          </div>`
          var callbacks = {};
          var self = this;
          callbacks.open = function() {
            $.magnificPopup.instance.wrap[0].addEventListener('focus', function (e) { 
              // document.querySelector("body").style.overflow = hidden;
              // alert("popup after open?");
              const element = document.getElementById("image-compare");
              const viewer = new ImageCompare(element, {
                fluidMode: true, 
                showLabels: true,
                labelOptions: {
                  before: self.firstComparitor.productTitle,
                  after: self.secondComparitor.productTitle,
                  onHover: true
                },
                controlColor: " #ffc3dd",
                controlShadow: false,
                addCircle: true,
                addCircleBlur: true // default
            }).mount();
            }, {once: true});
          };
          callbacks.close = function(){
            self.toggleBothComparitors();
          }
          this.openMFPInline(inlineString, 'mfp-comparitor', callbacks);
          break;
        case "second comparitor removed":
          // console.log("second comparitor removed " + e.detail.sender.className + " url: " + e.detail.featuredImageUrl + " title: " + e.detail.productTitle);
          console.log(`%c[MassTech / Card Information Buttons / Compare] second comparitor removed ${e.detail.productTitle}`, "color: Sienna");
          if (this.firstComparitor.selected) this.compareButton.classList.add("first_selected");
          this.secondComparitor = this.resetComparitor();
          break;
        default:
          console.log("%c[MassTech | Comparitor Switch] Error: Switch reached end.", "color:red");
      }
  }


  // 
  handleQuickView() {
    console.log(`%c[MassTech | Card Informtion Buttons] Fetching: ${this.productUrl}`, "color: chocolate");

    fetch(this.productUrl)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        // console.log(JSON.stringify(state));
        // console.log(html);
        var inlineString = getSectionInnerHTML(html, '#MainContent').trim();
        // console.log(inlineString);
        this.openMFPInline(inlineString, 'mfp-quick-view');        
      });
 
  }
  openMFPInline(inlineString, mfpClass = "mainClass", callbacks) {
    var config={items: {src: inlineString, type:'inline'}, mainClass: mfpClass};
    if(callbacks) {config.callbacks = callbacks;}
    $.magnificPopup.open(config);
  }
}



customElements.define('card-information-buttons', CardInformationButtons)